import { InputParamState, useInputParamState, ApiAllState, Notifications, SelectedSection } from "./Input-param-state";
import {  Network } from "../components/InterfaceInfo";
import { useAppPermanentState, AppPermanentState, StoredModels } from "./dynamic-perm-state";
import {  copySectionCalculations, deleteSectionCalculations, downloadReport, getAllStoredParams, getInputParameters, getValuesForRailway, getValuesForSections, LocationResponse, SectionData } from "../api-request/api-request";
import { DynamicInputParameters, ParameterGroup } from "../types/ApiData";
import { LocationParameters } from "../types/ApiData";
import { ParamFilterState } from "../pages/home/heat-map/GlobalFilter";
import { extractSchemaValues, normalizeBooleans } from "../utils/utils";

export const useNetwork = () => useInputParamState((state: InputParamState) => state.network) // return selected network
export const useStoredParameters = () => useAppPermanentState((state) => Object.keys(state.storedData).map((key) => JSON.parse(key)) as DynamicInputParameters[]); // return saved input parameters
export const useStored = () => useAppPermanentState((state) => {
    return Object.values(state.storedData) as SectionData[] | null;
});
export const useStoredAllData = () => useAppPermanentState(((state) => state.storedData as StoredModels)); // return all saved params and result

export const useSection = () => useInputParamState((state: InputParamState) => state.sections)
export const useData = () => useInputParamState((state: InputParamState) => state.data as ApiAllState);
export const useNotifications = () => useInputParamState((state: InputParamState) => state.notifications as Notifications)

/*export const useStoredLocationParams = () => useAppPermanentState(((state) => state.storedLocationParams as LocationParameters));
export const useStoredLocationData = () => useAppPermanentState(((state) => state.storedLocationData as LocationData));*/

export const useStoredLocationParams = () => useInputParamState(((state) => state.storedLocationParams as LocationParameters));
export const useStoredLocationData = () => useInputParamState(((state) => state.storedLocationData as LocationResponse));
export const useNetworkLoaded = () => useInputParamState((state: InputParamState) => state.networkLoaded);

/*** use schema */
/* use input params schema  */
export const useInputParams = () => useInputParamState((state: InputParamState) => {
    const inputParams = state.schemaParams.request_schema ?? []
    return inputParams
})

/* use response schema  */
export const useResponseSchema = () => useInputParamState((state: InputParamState) => {
    const responseSchema = state.schemaParams.response_schema ?? []
    return responseSchema
})

/* use buckling schema  */
export const useBucklingStateSchema = () => useInputParamState((state: InputParamState) => {
    const bucklingStatusSchema = state.schemaParams.buckling_statuses ?? []
    return bucklingStatusSchema
})

/* use user info schema  */
export const useUserInfoSchema = () => useInputParamState((state: InputParamState) => {
    const userInfoSchema = state.schemaParams.user_info ?? {}
    return userInfoSchema
})
/** schema end */

/* Get Input schema */
export const getInputParamsFromApi = async (paramState: InputParamState, accessToken: string) => {
    paramState.setData({ status: "loading" });
    const response = await getInputParameters(accessToken);
    if (response.status === "successful" && response.errors === '') {
        paramState.setSchemaParams(response.response);
    }
    paramState.setData(response);
    return response;
}

/* Get saved calculations  */
export const getSavedParameterDetails = async (paramState: InputParamState, permanentState: AppPermanentState, network_id: string, accessToken: string, storedInputParams: ParameterGroup[]) => {
    paramState.setData({ status: "loading" });
    const response = await getAllStoredParams(accessToken, network_id)
    if (response.status === "successful" && response.errors === '') {
        const { resultParams, resultResponse } = response.response?.points?.reduce(
            (acc, point) => {
                const { latitude, longitude, network_id } = point.location;
                const key = `${latitude},${longitude}`;

                acc.resultParams[key] = normalizeBooleans({
                    ...extractSchemaValues(storedInputParams, point),
                    network_id,
                });

                acc.resultResponse[key] = normalizeBooleans({
                    ...point,
                    network_id,
                });

                return acc;
            },
            {
                resultParams: {} as Record<string, any>,
                resultResponse: {} as Record<string, any>,
            }
        ) ?? {
            resultParams: {},
            resultResponse: {},
        };
        paramState.updateLocParams(resultParams, resultResponse, response, network_id, true)
        const global_settings = response.response?.global_result ?? {}
        if(global_settings && Object.keys(global_settings).length > 0) {
             const global_params = normalizeBooleans(extractSchemaValues(storedInputParams, global_settings))
             permanentState.insertData({...global_params, checked: true}, {...global_settings, checked: true},global_params.id);
        }
    }
}

/* get download url */
export const getDownloadFileUrl = async (requestItem: any, accessToken: string ) => {
    const response = await downloadReport(requestItem, accessToken);
    return response;
}

/* update global settings  */
export const updateInputParameters = async (paramState: InputParamState,permanentState : AppPermanentState,  params: DynamicInputParameters, accessToken: string, fromList : boolean, responseData  : SectionData | null, networkId: string, storedInputParams: ParameterGroup[], networkDetails?: any ) => {
    if(fromList && responseData) {
        paramState.setSection([]);
    }
    paramState.setData({ status: "loading" });
    const response = await getValuesForRailway(params, accessToken, networkDetails);
    paramState.setData(response);
    if (response.status === "successful" && response.errors === '') {
        let raw = response?.response?.sections[0].f;
        let fValue = raw != null ? String(raw) : null;
         if(fromList && responseData) {
            permanentState.insertData(params, responseData, networkId);
         } else {
            let modifiedResponse = normalizeBooleans(response?.response?.sections[0])
            permanentState.insertData({...params,f: fValue, checked: true}, {...modifiedResponse, checked:true},networkId);
         }
    }
    return response;
}

/* update location settings  */
export const updateLocationParameters = async (paramState: InputParamState, permanentState : AppPermanentState, params: DynamicInputParameters, accessToken: string, coord : string, coordDetails : {[key : string] : any}, networkDetails: any) => {
    paramState.setData({status : 'loading'}, true);
    const [latStr, longStr] = coord.split(',');
    const {network_id, ...Newparams} = params
    const response = await getValuesForSections(Newparams, accessToken,[parseFloat(latStr),parseFloat(longStr)], networkDetails);
    if (response.status === "successful") {
        paramState.setData(response, true);
        //paramState.setErrors(response.errors)
        if(response.errors === '') {
            paramState.insertstoredLocParamWithData({[coord] : {...params, network_id: networkDetails.network_id}}, {[coord] : {...response.response,  network_id: networkDetails.network_id}})
            let list = getNotifications(response.response, coord, coordDetails, 'You have new recommendation for ')
            paramState.setNotifications(list, false)
        }
    }
    return response;
}

/* update network  */
export const updateNetwork =  (paramState: InputParamState, value : Network) => { 
    paramState.setNetwork(value);   
}

/* update selected section  */
export const updateSelectedSection = (paramState: InputParamState, value : SelectedSection) => {
    paramState.setSection(value); 
}

/* delete global settings  */
export const deletePermenantData =  (permanentState : AppPermanentState, params: DynamicInputParameters, fromHistory : boolean) => {
    permanentState.deleteData(params,fromHistory);
}

/* delete Global Settings  */
export const delteGlobalSettings = async ( permanentState : AppPermanentState, params: DynamicInputParameters, fromHistory : boolean, paramState : InputParamState, id: string, accessToken: string, global? : boolean ) => {
    paramState.setData({ status: "loading" }, true);
    const data = {network_id: id, delete_global: global ?? false}
    const response = await deleteSectionCalculations(accessToken, data)
    if (response.status === "successful" && response.errors === '') {
        permanentState.deleteData(params,fromHistory);
        paramState.setData(response, true);
    }
}

/* delete location setting individual  */
export const deletePermenantLocData =  async ( paramState : InputParamState,accessToken: string, coord : string, network_id: string, section_id: string, global? : boolean) => {
    paramState.setData({ status: "loading" }, true);
    const data = {network_id: network_id, section_id: section_id, delete_global: global ?? false}
    const response = await deleteSectionCalculations(accessToken, data)
    if (response.status === "successful" && response.errors === '') {
        paramState.deleteStoredLocParams(coord)
        paramState.setData(response, true);
    }
}

/* delete location setting all individual  */
export const deleteAllPermenantLocData = async ( paramState : InputParamState, id: string, accessToken: string, global? : boolean ) => {
    paramState.setData({ status: "loading" }, true);
    const data = {network_id: id, delete_global: global ?? false}
    const response = await deleteSectionCalculations(accessToken, data)
    if (response.status === "successful" && response.errors === '') {
        paramState.deleteAllStoredLocParams(id)
        paramState.setData(response, true);
    }
}

/* copy params  */
export const copyParams = async (paramState: InputParamState, params: {[key: string] : DynamicInputParameters}, data: {[key: string] : SectionData}, coordDetails : {[key: string]: any}[] | [], source_name: string, target_sections: any[], network_name: string, accessToken: string) => {
        let requestParams = {network_id: network_name, target_locations: target_sections, section_id: source_name}
        paramState.setData({ status: "loading" },true);
        const response = await copySectionCalculations(accessToken, requestParams);
        if (response.status === "successful" && response.errors === '') {
            paramState.insertstoredLocParamWithData(params,data);
            let list = getNotificationsForCopy(coordDetails, 'You have successfully copied value for ')
            paramState.setNotifications(list, false)
        }
        paramState.setData(response,true);
}

/*** notifications */
export const updateReadStatus = (paramState: InputParamState,read : boolean, notif : Notifications) => {
    paramState.setNotifications(notif,read)
}

export const clearNotifications = (paramState: InputParamState) => {
    paramState.clearNotification()
}

/** get notification for recommendation */
const getNotifications = (response : SectionData,coord : string, coordDetails : {[key : string] : any}, message : string) => {
    let list : Notifications = {no_notifications : 0, notifications: [], read: false}
    if(response.recommendations && (response?.recommendations).length > 0) {
        let item = {id: coordDetails.id, name : coordDetails.name, coord : coordDetails.coordinates, message: message}
        list.notifications.push(item)
    }
    return list
}

/** get notification for copy */
const getNotificationsForCopy = (coordDetails : {[key : string] : any}[], message : string) => {
    let list : Notifications = {no_notifications : 0, notifications: [], read: false}
    if(coordDetails.length > 0) {
        coordDetails.map((item,key) => {
            let newItem = {id: item.id, name : item.name, coord : item.coordinates, message: message}
            list.notifications.push(newItem)
        })
    }
    return list
}
/** end of notifications */


/** tags functions */
export const updateTags = (tags:{edgeId: string,edgeName: string,index:number, lng:number,lat:number, tag: string, coordIndex: number, isGeoPoint: boolean}, permanentState : AppPermanentState) => {
    permanentState.addTagToPoint(tags)
}
export const DeleteTags = (id: string, permanentState : AppPermanentState) => {
    permanentState.deleteTaggedPoint(id)
}

export const useTags = (id: string) => {
    return useAppPermanentState(
        state => state.taggedPoints[id] ?? {}
    );
};

export const useAllTags = () => {
    return useAppPermanentState(
        state => state.taggedPoints ?? {}
    );
};

export const deleteAllTags = (permanentState : AppPermanentState) => {
    permanentState.deleteAllTags()
}
/** end of tag */

/** search functions */
export const useSearchMap = () => useInputParamState((state: InputParamState) => state.searchMap);
export const useIsSearchActive = () => useInputParamState((state: InputParamState) => state.isSearchActive);
export const useSearchText = () => useInputParamState((state: InputParamState) => state.searchText);

export const clearSearch = (paramState: InputParamState) => {
    paramState.clearSearch()
}

export const setSearchText = (paramState: InputParamState, text: string) => {
    paramState.setSearchText(text)
}

export const updateSearch = (paramState: InputParamState, map: Record<string,{ edgeMatch: boolean; coordMatches: Set<string> }> | {}, searchActive: boolean) => {
    paramState.setSearchMap(map)
    paramState.activateSearch(searchActive)
}

export const useParamFilterState = () => useInputParamState((state: InputParamState) => state.paramFilter);
export const updateFilter = (paramState: InputParamState, param: ParamFilterState) => {
    paramState.setParamFilter(param)
}
/** end of search */



